const data = {
  data: [
    {
      id: 2,
      name: 'Ramón',
      surname: 'García',
      email: 'ramon.garcia@zerocoma.com',
      company: 'Simbiosys',
      active: true,
      created_at: '21/10/2021'
    }
  ],
  links: {
    first: 'http://localhost/api/v1/businesses?page=1',
    last: 'http://localhost/api/v1/businesses?page=3',
    prev: null,
    next: 'http://localhost/api/v1/businesses?page=2'
  },
  meta: {
    current_page: 1,
    from: 1,
    last_page: 3,
    links: [
      {
        url: null,
        label: '&laquo; Anterior',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=1',
        label: '1',
        active: true
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: '2',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=3',
        label: '3',
        active: false
      },
      {
        url: 'http://localhost/api/v1/businesses?page=2',
        label: 'Siguiente &raquo;',
        active: false
      }
    ],
    path: 'http://localhost/api/v1/businesses',
    per_page: 20,
    to: 20,
    total: 41,
    search: {}
  }
}

export default data
